import { useEffect, useState } from "react";
import Layout from "../../../components/layout/Layout";
import Admin from "../../../components/auth/Admin";
import ProductContainers from "./ProductContainers";
import PurchaseContainers from "./PurchaseContainers";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";
import InfoComponent from "../../../components/InfoComponent";
import { makeStyles } from "@mui/styles";
import { Box, Tab, Tabs, Typography } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`container-tabpanel-${index}`}
      aria-labelledby={`container-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const useStyles = makeStyles(() => ({
  pageContent: {
    margin: 20,
    padding: 24,
  },
  tabContainer: {
    marginBottom: 8,
  },
  tabs: {
    "& .MuiTab-root": {
      marginRight: 32,
      textTransform: "none",
    },
  },
}));

const Container = () => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 0 },
              "@media (max-width: 455px)": {
                flexDirection: "column",
                alignItems: "flex-start",
              },
            }}
          >
            <Typography
              variant="h6"
              className="page-header"
              sx={{ whiteSpace: "nowrap" }}
            >
              Product Container
            </Typography>
          </Box>

          <InfoComponent pageKey="productContainers" />

          <Box sx={{ borderBottom: 1, borderColor: "divider" }} className={classes.tabContainer}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              className={classes.tabs}
            >
              <Tab label="Product Containers" />
              <Tab label="Purchase Containers" />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0} className={classes.tabContent}>
            <ProductContainers NotifyMessage={NotifyMessage} />
          </TabPanel>
          <TabPanel value={tabValue} index={1} className={classes.tabContent}>
            <PurchaseContainers NotifyMessage={NotifyMessage} />
          </TabPanel>

          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default Container;
